import {
  getReports,
  generateReport,
  downloadReport,
  deleteReport,
  getReportStats,
} from "./asyncThunks";

export const getReportsBuilder = (builder) => {
  builder.addCase(getReports.pending, (state) => {
    state.reports.loading = true;
    state.reports.error = null;
  });
  builder.addCase(getReports.fulfilled, (state, { payload }) => {
    state.reports.data = payload.data || [];
    state.reports.loading = false;
    
    // Update pagination info from response
    if (payload.pagination) {
      state.reports.pagination = {
        currentPage: payload.pagination.currentPage,
        totalPages: payload.pagination.totalPages,
        totalItems: payload.pagination.totalItems,
        itemsPerPage: payload.pagination.itemsPerPage,
        hasNextPage: payload.pagination.hasNextPage,
        hasPreviousPage: payload.pagination.hasPreviousPage,
      };
    }
  });
  builder.addCase(getReports.rejected, (state, action) => {
    state.reports.loading = false;
    state.reports.error = action.error.message;
  });
};

export const generateReportBuilder = (builder) => {
  builder.addCase(generateReport.pending, (state) => {
    state.generation.loading = true;
    state.stats.pendingReports += 1;
    state.generation.error = null;
  });
  builder.addCase(generateReport.fulfilled, (state, { payload }) => {
    state.generation.loading = false;
    state.generation.lastGenerated = payload.data;

    // Dodaj novi izveštaj u listu
    state.stats.totalReports += 0;
    state.stats.completedReports += 0;
    state.stats.pendingReports = 0;
    if (payload.data) {
      state.reports.data.unshift(payload.data);
    }
  });
  builder.addCase(generateReport.rejected, (state, action) => {
    state.generation.loading = false;
    state.stats.pendingReports = 0;
    state.generation.error = action.error.message;
  });
};

export const downloadReportBuilder = (builder) => {
  builder.addCase(downloadReport.pending, (state) => {
    state.download.loading = true;
  });
  builder.addCase(downloadReport.fulfilled, (state) => {
    state.download.loading = false;
    state.stats.totalDownloads += 1;
  });
  builder.addCase(downloadReport.rejected, (state, action) => {
    state.download.loading = false;
    state.download.error = action.error.message;
  });
};

export const getReportStatsBuilder = (builder) => {
  builder.addCase(getReportStats.pending, (state) => {
    state.stats.loading = true;
    state.stats.error = null;
  });
  builder.addCase(getReportStats.fulfilled, (state, { payload }) => {
    state.stats.loading = false;
    state.stats = payload.data;
  });
  builder.addCase(getReportStats.rejected, (state, action) => {
    state.stats.loading = false;
    state.stats.error = action.error.message;
  });
};

export const deleteReportsBuilder = (builder) => {
  builder.addCase(deleteReport.pending, (state) => {
    state.reports.deleteLoading = true;
    state.reports.error = null;
  });
  builder.addCase(deleteReport.fulfilled, (state, { payload }) => {
    state.reports.deleteLoading = false;

    state.reports.data = state.reports.data.filter(
      (report) => report.id !== payload.data.id
    );
  });
  builder.addCase(deleteReport.rejected, (state, action) => {
    state.reports.deleteLoading = false;
    state.reports.error = action.error.message;
  });
};
